import React from "react";
import { getStatusConfig } from "./lineItemPopupUtils";

interface StatusBadgeProps {
  status?: string;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = "" }) => {
  const config = getStatusConfig(status);
  return (
    <span
      className={`badge px-2.5 py-1 fs-12 fw-semibold d-inline-flex align-items-center gap-1 ${className}`}
      style={{
        backgroundColor: config.bgLight,
        color: config.color,
        border: `1px solid ${config.border}`,
      }}
    >
      <i className={config.icon} style={{ fontSize: "12px" }} />
      {config.label}
    </span>
  );
};

export const getStatusBadge = (status?: string) => <StatusBadge status={status} />;

export default StatusBadge;
